import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../layout/index";
import StepHeader from "./StepHeader";
import { APP_ROUTES } from "../../constants/approutes";
import { toast } from "react-toastify";
import axios from "axios";
// import CommonLoader from "../../components/CommonLoader";
import { DatePicker, Modal } from "antd";
import dayjs from "dayjs";
import FullScreenLoader from "../FullScreenLoader";
import { Select } from "antd";
import ConsentModal from "../Consent/ConsentModal";
import VitalDetails from "./VitalDetails";
import MedicalhistoryPage from "./MedicalHistory";
import VerifyAbhaModal from "../ABHA/VerifyAbhaModal";
import CreateAbhaModal from "../ABHA/CreateAbhaModal";
import searchicon from "../../assets/search_icon.svg";
import patientvectoricon from "../../assets/patientvectoricon.svg";
import State, { getStateCode } from "../../state";
import { Share2 } from "lucide-react";
const { Option } = Select;

function Patientregister() {
  const disabledFeatures = JSON.parse(
    localStorage.getItem("disabledFeatures") || "[]",
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { patientCode, mobileNumber } = location.state || {};
  const predictedVitals = JSON.parse(sessionStorage.getItem("predictedVitals"));
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get("from");
  const API_URL = process.env.REACT_APP_API_URL;
  const hospitalId = localStorage.getItem("hospitalid") || "";
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const parentCode = location.state?.parentCode;
  const [symptomsList, setSymptomsList] = useState([]);
  const [submitted, setSubmitted] = useState(predictedVitals ? true : false);
  const [showAbhaModal, setShowAbhaModal] = useState(false);
  const [showCreateAbhaModal, setShowCreateAbhaModal] = useState(false);
  const [isAbhaVerified, setIsAbhaVerified] = useState(false);
  const [vitalsData, setVitalsData] = useState(null);
  const [showVitalsData, setShowVitalsData] = useState(false);
  const [medicalData, setMedicalData] = useState(null);
  const [showMedicalData, setShowMedicalData] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [viewMode, setViewMode] = useState("desktop"); // 'm
  const [isAbhaVerifyOpen, setIsAbhaVerifyOpen] = useState(false);
  const [isAbhaCreateOpen, setIsAbhaCreateOpen] = useState(false);
  const [selectedPatientForAbha, setSelectedPatientForAbha] = useState(null);
  const [sendingKavachCode, setSendingKavachCode] = useState(null);
  console.log(predictedVitals, patientCode, "parentCode");
  const [sendingQuantumCode, setSendingQuantumCode] = useState(null);

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    gender: "",
    relation: "",
    dob: "",
    age: "",
    mobile: (mobileNumber || "").toString().replace(/[^0-9]/g, ""),
    address: "",
    city: "",
    pinCode: "",
    state: "",
    chiefComplaint: [],
    salutation: "",
    abhaNumber: "",
    preferredAbhaAddress: "",
    alternateMobile: "",
  });
  const [loading, setLoading] = useState(false);
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [createdPatientId, setCreatedPatientId] = useState(
    patientCode && predictedVitals ? patientCode : null,
  );
  const [createdMobile, setCreatedMobile] = useState("");
  const [createdPatientData, setCreatedPatientData] = useState(null);
  const [createdCurebayPatientId, setCreatedCurebayPatientId] = useState(null);
  const [openModal, setOpenModal] = useState(predictedVitals ? true : false);
  const [openModal2, setOpenModal2] = useState(null);
  const [selectedPatientCode, setSelectedPatientCode] = useState();
  const [prescriptionUrl, setPrescriptionUrl] = useState("");
  const [labReports, setLabReports] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  // Pincode and address related state
  const [areaOptions, setAreaOptions] = useState([]);
  const [fetchedState, setFetchedState] = useState("");
  const [fetchedCity, setFetchedCity] = useState("");
  const [fetchedCountry, setFetchedCountry] = useState("");

  const getQuantumUrl = () => {
    const base = String(process.env.REACT_APP_QUANTUM_URL || "").replace(
      /\/$/,
      "",
    );
    return base ? `${base}/` : "";
  };
  // Error state for alternate mobile validation
  const [alternateMobileError, setAlternateMobileError] = useState("");
  const [dobError, setDobError] = useState("");
  const handleSendKavachLink = async (user) => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      toast.error("Please login to send Kavach link.");
      return;
    }

    const mobileNumber = String(user.mobileNumber || "").replace(/\D/g, "");
    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Valid 10-digit mobile number is required.");
      return;
    }

    const patientName = [user.firstName, user.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    if (!patientName) {
      toast.error("Patient name is required.");
      return;
    }

    if (!hospitalId) {
      toast.error("Hospital ID not found.");
      return;
    }

    try {
      setSendingKavachCode(user.patientCode);
      const res = await fetch(`${API_URL}curebayKavach/send-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mobileNumber,
          patientName,
          hospitalId,
        }),
      });

      if (res.ok) {
        toast.success("Kavach link sent successfully.");
        return;
      }

      let msg = "Failed to send Kavach link.";
      try {
        const data = await res.json();
        msg = data?.message || data?.error || msg;
      } catch (_) {
        /* ignore parse errors */
      }
      toast.error(msg);
    } catch (err) {
      console.error("Send Kavach link error:", err);
      toast.error("Something went wrong while sending Kavach link.");
    } finally {
      setSendingKavachCode(null);
    }
  };
  const SearchResultMobileCard = ({ user, idx }) => (
    <div className="border-b border-gray-200 pb-4 last:border-b-0">
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <h3 className="font-medium text-gray-900 capitalize text-sm">
            {user.firstName} {user.lastName}
          </h3>
          <p className="text-sm text-gray-600 mt-1">{user.mobileNumber}</p>
          <p className="text-sm text-gray-600">Age: {user.age}</p>
        </div>
      </div>
      <div className="flex gap-2 mt-3">
        {!user.parentCode && (
          <button
            className="flex-1 text-xs py-2 px-3 text-green-600 bg-green-50 rounded-md hover:bg-green-100 transition-colors"
            onClick={() => {
              setSearchResults([]); // Close search results
              setSearchInput(""); // Clear search input
              navigate("/Patientregister", {
                state: { parentCode: user.patientCode },
              });
            }}
          >
            +Add Member
          </button>
        )}
        <button
          className="flex-1 text-xs py-2 px-3 text-white bg-[#004276] rounded-md hover:bg-[#003661] transition-colors"
          onClick={() =>
            navigate("/BookServicescard", {
              state: { patientCode: user.patientCode, patient: user },
            })
          }
        >
          Book
        </button>
      </div>
    </div>
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchInput.trim().length >= 3) {
        handleSearch();
      } else {
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  // useEffect to fetch address when pincode is 6 digits
  // useEffect(() => {
  //   if (formData.pinCode && formData.pinCode.length === 6) {
  //     fetchAddressByPincode(formData.pinCode);
  //   }
  // }, [formData.pinCode]);

  // Reset form when Add Member is clicked (parentCode is present)
  useEffect(() => {
    if (parentCode) {
      setFormData({
        firstname: "",
        lastname: "",
        gender: "",
        relation: "",
        dob: "",
        mobile: "",
        address: "",
        city: "",
        pinCode: "",
        state: "",
        chiefComplaint: [],
        salutation: "",
        abhaNumber: "",
        preferredAbhaAddress: "",
        alternateMobile: "",
      });
      // Also reset other related states
      setFetchedState("");
      setFetchedCity("");
      setFetchedCountry("");
      setAreaOptions([]);
      setAlternateMobileError("");
      setDobError("");
    }
  }, [parentCode]);

  const handleSearch = async () => {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const input = searchInput.trim();

    const isMobile = /^[0-9]+$/.test(input);
    const searchParam = isMobile
      ? `mobileNumber=${input}`
      : `firstName=${input}`;

    const url = `${API_URL}patient/search?${searchParam}`;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      });

      const data = await res.json();

      if (Array.isArray(data.data)) {
        setSearchResults(data.data);
      } else {
        setSearchResults([]);
        toast.error("No patient found.");
      }
    } catch (error) {
      console.error("Search error:", error);
      toast.error("Something went wrong while searching.");
    }
  };

  // Function to calculate age from date of birth
  const calculateAge = (dob) => {
    if (!dob) return "";
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age.toString();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle DOB change and calculate age
    if (name === "dob") {
      const age = calculateAge(value);
      setFormData((f) => ({ ...f, [name]: value, age: age }));
      setDobError(validateDateOfBirth(value) || "");
      return;
    }

    // Validation for specific fields
    if (name === "firstname" || name === "lastname") {
      // Allow only letters and spaces
      const filteredValue = value.replace(/[^a-zA-Z ]/g, "");
      setFormData((f) => ({ ...f, [name]: filteredValue }));
      return;
    }
    if (
      name === "pinCode" ||
      name === "mobile" ||
      name === "alternateMobile" ||
      name === "age"
    ) {
      // Allow only numbers
      const filteredValue = value.replace(/[^0-9]/g, "");

      if (name === "pinCode") {
        if (filteredValue.length < 6) {
          setFetchedState("");
          setFetchedCity("");
        }
        setFormData((f) => ({
          ...f,
          pinCode: filteredValue,
          ...(filteredValue.length < 6 ? { state: "", city: "" } : {}),
        }));
        if (filteredValue.length === 6) {
          fetchAddressByPincode(filteredValue);
        }
        return;
      }

      setFormData((f) => ({ ...f, [name]: filteredValue }));

      // Validate alternate mobile number
      if (name === "alternateMobile") {
        if (filteredValue && filteredValue.length !== 10) {
          setAlternateMobileError("Please enter a 10 digit mobile number");
        } else {
          setAlternateMobileError("");
        }
      }
      return;
    }
    setFormData((f) => ({ ...f, [name]: value }));
  };

  // Function to fetch address details by pincode
  const fetchAddressByPincode = async (pincode) => {
    try {
      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      const response = await axios.get(
        `${process.env.REACT_APP_NEWBASEURL}getAllAddressDetails/list?pincode=${pincode}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        },
      );

      console.log("Address API response:", response.data.data);

      if (response.data.data && response.data.data.length > 0) {
        const addressData = response.data.data[0]; // Take first entry since all have same state/district

        // Create area options for dropdown
        const areas = response.data.data.map((item) => ({
          value: item.area,
          label: item.area,
          key: item.area,
        }));
        setAreaOptions(areas);

        const stateCode = getStateCode(addressData.state || "");

        setFetchedState(stateCode);
        setFetchedCity(addressData.area || "");
        setFetchedCountry("India");

        setFormData((prev) => ({
          ...prev,
          state: stateCode,
          city: addressData.area || "",
        }));

        console.log("Address fields updated:", {
          state: addressData.state,
          stateCode,
          city: addressData.area,
          country: "India",
        });
      } else {
        setFetchedState("");
        setFetchedCity("");
        setFormData((prev) => ({ ...prev, state: "", city: "" }));
      }
    } catch (error) {
      console.error("Error fetching address details:", error);
      setFetchedState("");
      setFetchedCity("");
      toast.error("Failed to fetch address details");
    }
  };

  // const calculateAge = (dob) => {
  //   const birth = new Date(dob);
  //   const today = new Date();
  //   let age = today.getFullYear() - birth.getFullYear();
  //   const m = today.getMonth() - birth.getMonth();
  //   if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  //   return age;
  // };

  const validateDateOfBirth = (dob) => {
    if (!dob) return "Date of birth is required";

    const selectedDate = new Date(dob);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day

    if (selectedDate >= today) {
      return "Date of birth cannot be today or a future date. Please enter a valid date.";
    }

    // Check if age is reasonable (e.g., not more than 150 years)
    const age = calculateAge(dob);
    if (age > 150) {
      return "Please enter a valid date of birth. Age cannot exceed 150 years.";
    }

    return null; // No error
  };

  const isFormValid = () =>
    (formData.firstname || "").trim() &&
    (formData.lastname || "").trim() &&
    formData.gender &&
    (formData.dob || "").trim() &&
    !validateDateOfBirth(formData.dob) &&
    (formData.mobile || "").trim().length === 10 &&
    (formData.address || "").trim() &&
    (formData.pinCode || "").trim().length === 6;
  // (formData.chiefComplaint || "").trim();
  // formData.chiefComplaint.length > 0;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleregister = async (patientDetails) => {
    console.log(patientDetails, "patientDetails");
    const tenantId = localStorage.getItem("tenantId");
    try {
      // Step 1: Patient Registration
      const token = localStorage.getItem("access_token");

      const firstName = localStorage.getItem("firstName");
      const lastName = localStorage.getItem("lastName");
      const payload = {
        salutation: patientDetails.salutation,
        mobileNumber: patientDetails.mobileNumber,
        firstName: patientDetails.firstName,
        lastName: patientDetails.lastName,
        email: "",
        password: "Test@123",
        dob: formatDate(patientDetails.dob),
        gender:
          patientDetails.gender == "male"
            ? "M"
            : patientDetails.gender == "female"
              ? "F"
              : "O",
        address1: patientDetails.address || "",
        address2: patientDetails.address || "",
        pincode: patientDetails.pinCode,
        city: patientDetails.city || "",
        state: patientDetails.state,
        country: "India",
        privacyPolicy: "Y",
        termsCondition: "Y",
        source: "HOSPI360",
        hospitalId: localStorage.getItem("hospitalid"),
        createdBy: firstName + " " + lastName,
        modifiedBy: firstName + " " + lastName,
      };
      console.log(payload, "payloadjhbkj");

      const registerResponse = await fetch(
        `${process.env.REACT_APP_API_URL_PATIENTS}patient-user/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      console.log(registerResponse.status, "registration status");
      const registerResult = await registerResponse.json();


      if (registerResult.status == 400) {
        const authToken = localStorage.getItem("auth_token");
        const curebayPatientId = registerResult.data?.patientId || "";
        setCreatedCurebayPatientId(curebayPatientId);
        const updatePayload = {
          curebayPatientId: registerResult.data?.patientId,
          firstName: patientDetails.firstName,
          lastName: patientDetails.lastName,
          gender: patientDetails.gender,
          mobileNumber: patientDetails.mobileNumber, // Fixed: was patient.mobileNumber
        };
        console.log(updatePayload, "update payload");

        const updateResponse = await fetch(
          `${API_URL}patient/update/${patientDetails.patientId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
              tenantId: tenantId,
            },
            body: JSON.stringify(updatePayload),
          },
        );

        if (updateResponse.ok) {
          const updateResult = await updateResponse.json();
          console.log(updateResult, "update response data");

          // Update local patientDetails
          // patientDetails.curebayPatientId = updatePayload.curebayPatientId;
          // fetchPatientdetails(patientDetails.patientCode);
          // return {
          //   registration: registerResult,
          //   update: updateResult,
          //   curebayPatientId: updatePayload.curebayPatientId,
          // };
        } else {
          const updateError = await updateResponse.json();
          throw new Error(updateError.message || "Patient update failed");
        }
      } else if (registerResponse.status === 200) {
        // Step 2: Update Patient with curebayPatientId
        const authToken = localStorage.getItem("auth_token");
        const curebayPatientId = registerResult.data?.patientCode || "";
        setCreatedCurebayPatientId(curebayPatientId);
        const updatePayload = {
          firstName: patientDetails.firstName,
          lastName: patientDetails.lastName,
          gender: patientDetails.gender,
          mobileNumber: patientDetails.mobileNumber, // Fixed: was patient.mobileNumber
          curebayPatientId: registerResult.data?.patientCode,
        };

        const updateResponse = await fetch(
          `${API_URL}patient/update/${patientDetails.patientId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
              tenantId: tenantId,
            },
            body: JSON.stringify(updatePayload),
          },
        );

        if (updateResponse.ok) {
          const updateResult = await updateResponse.json();
          console.log(updateResult, "update response data");

          // Update local patientDetails
          // patientDetails.curebayPatientId = updatePayload.curebayPatientId;
          // fetchPatientdetails(patientDetails.patientCode);
          // return {
          //   registration: registerResult,
          //   update: updateResult,
          //   curebayPatientId: updatePayload.curebayPatientId,
          // };
        } else {
          const updateError = await updateResponse.json();
          throw new Error(updateError.message || "Patient update failed");
        }
      } else {
        const registerError = await registerResponse.json();
        throw new Error(registerError.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration process error:", error);
      throw error;
    }
  };

  const handleNext = async () => {
    const dobValidationError = validateDateOfBirth(formData.dob);
    if (dobValidationError) {
      setDobError(dobValidationError);
      toast.error(dobValidationError);
      return;
    }

    if (!isFormValid()) {
      if (!formData.dob?.trim()) {
        setDobError("Date of birth is required");
        toast.error("Please select date of birth");
        return;
      }
      if (!formData.pinCode || formData.pinCode.trim().length !== 6) {
        toast.error("Please enter a valid 6-digit pincode");
        return;
      }
      if (!(formData.address || "").trim()) {
        toast.error("Please enter address");
        return;
      }
      return;
    }
    const tenantId = localStorage.getItem("tenantId");
    setLoading(true);
    setIsLoggingIn(true);
    const payload = {
      firstName: formData.firstname,
      lastName: formData.lastname,
      gender: formData.gender,
      relationshipStatus: formData.relation,
      age: formData.age,
      dob: formData.dob,
      mobileNumber: formData.mobile,
      alternatemobileNumber: formData.alternateMobile,
      // chiefComplaint: formData.chiefComplaint,
      // chiefComplaint: formData.chiefComplaint.join(", "),
      address: formData.address?.trim() || "",
      city: formData.city?.trim() || "",
      state: formData.state || "",
      parentCode: parentCode ? parentCode : null,
      pinCode: formData.pinCode,
      salutation: formData.salutation,

      abhaNumber: formData.abhaNumber || null,
      preferredAbhaAddress: formData.preferredAbhaAddress || null,
      tenantId: tenantId,
      country: "IND",
    };
    console.log(payload, "rdftgyhujiok");

    const token = localStorage.getItem("auth_token");

    try {
      const res = await fetch(`${API_URL}patient/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
        body: JSON.stringify(payload),
      });
      const result = await res.json();
      handleregister({
        ...result,
        state: formData.state,
        pinCode: formData.pinCode,
        address: formData.address,
        city: formData.city,
        country: "IND",
      });
      setIsLoggingIn(false);
      console.log(result, "tdryguio");
      localStorage.setItem("patientcode", result.patientId);
      setCreatedPatientId(result.patientId);
      setCreatedPatientData(result);
      setCreatedMobile(formData.mobile);
      setTimeout(() => {
        if (res.ok) {
          toast.success("Patient Details Save Successfully!");
          setShowConsentModal(true);
          setSubmitted(true);
        } else {
          toast.error(result.error);
          setLoading(false);
        }
      }, 1000);
    } catch (err) {
      console.error(err);
      toast.error(err);
      setLoading(false);
    }
  };

  const handleConsentComplete = () => {
    setShowConsentModal(false);
    setLoading(false);
    // navigate(APP_ROUTES.VITAL, {
    //   state: {
    //     patientCode: createdPatientId,
    //   },
    // });
  };

  const handleConsentSkip = () => {
    setShowConsentModal(false);
    setLoading(false);
    // navigate(APP_ROUTES.VITAL, {
    //   state: {
    //     patientCode: createdPatientId,
    //   },
    // });
  };

  const handleVitalsComplete = (vitalsResult) => {
    setVitalsData(vitalsResult);
    setOpenModal(false);
  };

  const handleAddVitalsClick = () => {
    if (vitalsData) {
      // If vitals are already added, show the data
      setShowVitalsData(true);
    } else {
      // If no vitals added yet, open the vitals modal
      setOpenModal(true);
    }
  };

  const handleMedicalComplete = (historyResult) => {
    setMedicalData(historyResult);
    setOpenModal2(false);
  };

  const handleAddMedicalClick = () => {
    if (medicalData) {
      setShowMedicalData(true);
    } else {
      setOpenModal2(true);
    }
  };

  useEffect(() => {
    const fetchSymptoms = async () => {
      try {
        const token = localStorage.getItem("auth_token");

        const res = await fetch(
          `${process.env.REACT_APP_NEW_DOCTOR_URL}/Symptoms/list`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        const data = await res.json();
        console.log("API Data:", data);

        if (Array.isArray(data)) {
          // If API directly returns the array (rare case)
          setSymptomsList(data);
        } else if (Array.isArray(data?.data)) {
          // Normal structure
          setSymptomsList(data.data);
        } else {
          console.warn("Unexpected symptoms format");
        }
      } catch (error) {
        console.error("Error fetching symptoms:", error);
      }
    };

    fetchSymptoms();
  }, []);

  // Check if vitals data already exists for this patient
  useEffect(() => {
    if (createdPatientId) {
      const storedVitalsData = localStorage.getItem("vitaldata");
      if (storedVitalsData) {
        try {
          const parsedData = JSON.parse(storedVitalsData);
          // Check if the vitals data belongs to the current patient
          if (parsedData.patientCode === createdPatientId) {
            setVitalsData(parsedData);
          }
        } catch (error) {
          console.error("Error parsing stored vitals data:", error);
        }
      }

      const storedMedicalData = localStorage.getItem("medicaldata");
      if (storedMedicalData) {
        try {
          const parsedMed = JSON.parse(storedMedicalData);
          if (parsedMed.patientCode === createdPatientId) {
            setMedicalData(parsedMed);
          }
        } catch (error) {
          console.error("Error parsing stored medical data:", error);
        }
      }
    }
  }, [createdPatientId]);

  // Fetch signed URLs for prescription and lab reports like PatientPreview
  useEffect(() => {
    if (!medicalData) return;
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchPrescription = async () => {
      try {
        if (!medicalData.documentUrl) return;
        const res = await fetch(
          `${baseUrl}patient-medical-history/file-url?fileName=${medicalData.documentUrl}`,
          { headers: { Authorization: `Bearer ${token}`, tenantId } },
        );
        const data = await res.json();
        if (data?.signedUrl) setPrescriptionUrl(data.signedUrl);
      } catch (err) {
        console.error("Error fetching prescription URL", err);
      }
    };

    const fetchLabReports = async () => {
      try {
        const files = Array.isArray(medicalData.labReportUrls)
          ? medicalData.labReportUrls
          : [];
        const urls = await Promise.all(
          files.map(async (fileName) => {
            const res = await fetch(
              `${baseUrl}patient-medical-history/file-url?fileName=${fileName}`,
              { headers: { Authorization: `Bearer ${token}`, tenantId } },
            );
            const data = await res.json();
            return { name: fileName, signedUrl: data?.signedUrl };
          }),
        );
        setLabReports(urls.filter((u) => !!u.signedUrl));
      } catch (err) {
        console.error("Error fetching lab reports", err);
      }
    };

    setPrescriptionUrl("");
    setLabReports([]);
    fetchPrescription();
    fetchLabReports();
  }, [medicalData]);

  const checkAbhaVerified = (patient) => {
    return patient.abhaNumber && patient.preferredAbhaAddress;
  };
  const handleAbhaVerify = (patient) => {
    setSelectedPatientForAbha(patient);
    setIsAbhaVerifyOpen(true);
  };

  const handleAbhaClose = () => {
    setIsAbhaVerifyOpen(false);
    setIsAbhaCreateOpen(false);
    setSelectedPatientForAbha(null);
  };
  // const handleAbhaSuccess = () => {
  //   setIsAbhaVerifyOpen(false);
  //   setIsAbhaCreateOpen(false);
  //   setSelectedPatientForAbha(null);
  //   // Refresh search results to show updated ABHA status
  //   if (searchInput.trim().length >= 3) {
  //     handleSearch();
  //   }
  // };

  const handleAbhaSuccess = async (abhaData) => {
    try {
      // Parse ABHA data from verification/creation responses
      let abhaNumber = "";
      let preferredAbhaAddress = "";

      if (abhaData?.abhaProfile) {
        abhaNumber = abhaData.abhaProfile.abhaNumber || "";
        preferredAbhaAddress = abhaData.abhaProfile.preferredAbhaAddress || "";
      } else if (abhaData?.healthIdNumber) {
        abhaNumber = abhaData.healthIdNumber || "";
        preferredAbhaAddress = abhaData.preferredAbhaAddress || "";
      }

      const token = localStorage.getItem("auth_token");
      const tenantId = localStorage.getItem("tenantId");

      if (selectedPatientForAbha?.patientCode) {
        const updatePayload = {
          firstName: selectedPatientForAbha.firstName,
          lastName: selectedPatientForAbha.lastName,
          gender: selectedPatientForAbha.gender,
          mobileNumber: selectedPatientForAbha.mobileNumber,
          abhaNumber: abhaNumber,
          preferredAbhaAddress: preferredAbhaAddress,
        };

        const res = await fetch(
          `${API_URL}patient/update/${selectedPatientForAbha.patientCode}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              tenantId: tenantId,
            },
            body: JSON.stringify(updatePayload),
          },
        );

        if (res.ok) {
          toast.success("Patient ABHA information updated successfully!");
        } else {
          try {
            const data = await res.json();
            toast.error(
              data?.message || "Failed to update patient ABHA information",
            );
          } catch (_) {
            toast.error("Failed to update patient ABHA information");
          }
        }
      }
    } catch (error) {
      console.error("Error updating patient ABHA information:", error);
      toast.error("Failed to update patient ABHA information");
    } finally {
      setIsAbhaVerifyOpen(false);
      setIsAbhaCreateOpen(false);
      setSelectedPatientForAbha(null);
      // Refresh search results to show updated ABHA status
      if (searchInput.trim().length >= 3) {
        handleSearch();
      }
    }
  };
  const getHealthSessionBaseUrl = () =>
    String(process.env.REACT_APP_HEALTH_SESSION_URL || "").replace(/\/$/, "");

  const patientSearchActionBtn =
    "inline-flex items-center justify-center gap-2 rounded-xl text-sm font-semibold transition-opacity hover:opacity-90 whitespace-nowrap min-w-[100px]";
  const SHARE_LINK_GRADIENT_ID = "patientShareLinkGrad";
  const PatientShareLinkButton = ({
    label,
    loadingLabel = "Sending...",
    onClick,
    disabled,
    isLoading,
  }) => (
    <button
      type="button"
      className={`${patientSearchActionBtn} w-full min-w-[152px] cursor-pointer p-[2px] bg-gradient-to-r from-[#1E4D7B] to-[#59B482] hover:opacity-95 disabled:opacity-60 disabled:cursor-not-allowed`}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="inline-flex w-full items-center justify-center gap-2 rounded-[10px] bg-white px-4 py-2.5">
        <Share2
          className="h-4 w-4 shrink-0"
          stroke={`url(#${SHARE_LINK_GRADIENT_ID})`}
          strokeWidth={2.5}
        />
        <span className="bg-gradient-to-r from-[#1E4D7B] to-[#59B482] bg-clip-text text-sm font-semibold text-transparent">
          {isLoading ? loadingLabel : label}
        </span>
      </span>
    </button>
  );
  const handleSendQuantumLink = async (user) => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      toast.error("Please login to send Quantum link.");
      return;
    }

    const baseUrl = getHealthSessionBaseUrl();
    if (!baseUrl) {
      toast.error(
        "Health session URL is not configured. Set REACT_APP_HEALTH_SESSION_URL and restart the app.",
      );
      return;
    }

    const patientId = user.curebayPatientId;
    if (!patientId) {
      toast.error("CureBay patient ID not found for this patient.");
      return;
    }

    const mobileNumber = String(user.mobileNumber || "").replace(/\D/g, "");
    if (!/^\d{10}$/.test(mobileNumber)) {
      toast.error("Valid 10-digit mobile number is required.");
      return;
    }

    const patientName = [user.firstName, user.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
    if (!patientName) {
      toast.error("Patient name is required.");
      return;
    }

    try {
      setSendingQuantumCode(user.patientCode);

      const sessionRes = await fetch(`${baseUrl}/aes-sessions`, {
        method: "POST",
        headers: {
          accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          patientId,
          isActive: true,
          sourceChannel: "D2C",
        }),
      });

      let sessionData = {};
      try {
        sessionData = await sessionRes.json();
      } catch (_) {
        /* ignore empty or non-JSON body */
      }

      if (!sessionRes.ok) {
        const msg =
          sessionData?.message ||
          sessionData?.error ||
          "Failed to create health session.";
        toast.error(msg);
        return;
      }

      const sessionId = sessionData?.sessionId;
      if (!sessionId) {
        toast.error("Session ID not returned from health session API.");
        return;
      }

      const sendLinkRes = await fetch(`${API_URL}upscale/quantum/send-link`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mobileNumber,
          patientName,
          sessionId,
        }),
      });

      let sendLinkData = {};
      try {
        sendLinkData = await sendLinkRes.json();
      } catch (_) {
        /* ignore empty or non-JSON body */
      }

      if (sendLinkRes.ok) {
        toast.success("Quantum link sent successfully.");
        return;
      }

      const msg =
        sendLinkData?.message ||
        sendLinkData?.error ||
        "Failed to send Quantum link.";
      toast.error(msg);
    } catch (err) {
      console.error("Send Quantum link error:", err);
      toast.error("Something went wrong while sending Quantum link.");
    } finally {
      setSendingQuantumCode(null);
    }
  };

  const handleExploreQuantum = () => {
    const url = getQuantumUrl();
    if (!url) {
      toast.error(
        "Quantum URL is not configured. Set REACT_APP_QUANTUM_URL and restart the app.",
      );
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      {isLoggingIn && <FullScreenLoader message="Saving Patient Info..." />}
      <ConsentModal
        visible={showConsentModal}
        onClose={handleConsentSkip}
        patientId={createdPatientId}
        mobileNumber={createdMobile}
        serviceType="APPT_SERVICE"
        onConsentComplete={handleConsentComplete}
      />

      <DashboardLayout>
        <div className="min-h-screen px-2 sm:px-4  bg-white">
          <StepHeader />

          {/* Compact Search Section */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 rounded-xl p-3 mb-6 shadow-sm">
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
              {/* Left Section - Title */}
              <div className="flex items-center gap-3">
                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-1.5 rounded-lg mb-[8px]">
                  <img
                    src={patientvectoricon}
                    alt="Patient"
                    className="w-4 h-4 filter brightness-0 invert"
                  />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">
                    Searching for a Patient ?
                  </h2>
                </div>
              </div>

              {/* Right Section - Search and Register */}
              <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center w-full lg:w-auto">
                {/* Compact Search Input */}
                <div className="relative flex-1 sm:min-w-[250px] lg:min-w-[280px]">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search by name or mobile number..."
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      className="w-full px-4 py-2.5 pr-10 text-gray-700 bg-white border-2 border-gray-200 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 placeholder-gray-400 text-sm"
                    />
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                      <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-1 rounded-md">
                        <img
                          src={searchicon}
                          alt="Search"
                          className="w-3.5 h-3.5 filter brightness-0 invert"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Beautiful Search Results */}
          {searchResults.length > 0 && (
            <div className="mt-4 bg-white border border-gray-300 rounded-md shadow-sm overflow-hidden">
              {viewMode === "mobile" ? (
                // Mobile View - Cards
                <div className="p-4 space-y-4">
                  {searchResults.map((user, idx) => (
                    <SearchResultMobileCard key={idx} user={user} idx={idx} />
                  ))}
                </div>
              ) : (
                // Tablet & Desktop View - Table
                <div className="overflow-x-auto">
                  <table className="min-w-full text-sm">
                    <thead className="bg-gray-100 text-gray-700 font-semibold">
                      <tr>
                        <th className="p-2 text-left">Name</th>
                        <th className="p-2 text-left">Phone Number</th>
                        {!disabledFeatures.includes("ABDM") && (
                          <th className="p-2 text-left">ABHA Status</th>
                        )}
                        <th className="p-2 text-left">Age</th>
                        <th className="p-2 text-left">Add Family</th>
                        <th className="p-2 text-left">Book Services</th>
                        <th className="p-2 text-left">Share Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchResults.map((user, idx) => (
                        <tr key={idx} className="border-t">
                          <td className="p-2 capitalize">
                            {user.firstName} {user.lastName}
                          </td>
                          <td className="p-2">{user.mobileNumber}</td>
                          <td className="p-2">{user.age}</td>
                          {!disabledFeatures.includes("ABDM") && (
                            <td className="p-2">
                              {checkAbhaVerified(user) ? (
                                <div className="relative overflow-hidden bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 border border-green-200/60 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300">
                                  {/* Background Pattern */}
                                  <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-green-200/20 to-transparent rounded-full -translate-y-4 translate-x-4"></div>

                                  <div className="relative flex items-center gap-3">
                                    <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full shadow-md">
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <div className="flex items-center gap-2 mb-1.5">
                                        <span className="text-xs font-bold text-green-800 tracking-wide">
                                          Verified
                                        </span>
                                      </div>
                                      <div className="bg-white/70 backdrop-blur-sm border border-green-200/50 rounded px-2 py-1.5">
                                        <div
                                          className="text-xs text-green-700 font-mono font-semibold tracking-wider truncate"
                                          title={user.abhaNumber}
                                        >
                                          {user.abhaNumber}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="relative overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-red-50 border border-orange-200/60 rounded-lg p-3 shadow-sm hover:shadow-md transition-all duration-300">
                                  {/* Background Pattern */}
                                  <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-orange-200/20 to-transparent rounded-full -translate-y-4 translate-x-4"></div>

                                  <div className="relative flex items-center gap-3">
                                    <div className="flex items-center justify-center w-8 h-8 bg-gradient-to-br from-orange-400 to-red-500 rounded-full shadow-md">
                                      <svg
                                        className="w-4 h-4 text-white"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <div className="flex items-center gap-2 mb-2">
                                        <span className="text-xs font-bold text-orange-800 tracking-wide">
                                          Not Verified
                                        </span>
                                      </div>
                                      <button
                                        onClick={() => handleAbhaVerify(user)}
                                        className="group relative bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600 hover:from-blue-600 hover:via-blue-700 hover:to-indigo-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-md shadow-sm"
                                      >
                                        <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-indigo-500 rounded-lg opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                                        <div className="relative flex items-center gap-1.5">
                                          <svg
                                            className="w-3 h-3"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                          <span>Verify ABHA</span>
                                        </div>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </td>
                          )}
                          {!user.parentCode && (
                            <td
                              className="p-2 text-green-600 cursor-pointer hover:underline"
                              onClick={() => {
                                setSearchResults([]); // Close search results
                                setSearchInput(""); // Clear search input
                                navigate("/Patientregister", {
                                  state: { parentCode: user.patientCode },
                                });
                              }}
                            >
                              +Add Member
                            </td>
                          )}
                          {user.parentCode && (
                            <td className="p-2 text-gray-400">Family Member</td>
                          )}
                          <td className="p-2">
                            <button
                              className="p-2 text-white cursor-pointer bg-[#004276] py-2 px-8 rounded-md hover:bg-[#003661] transition-colors"
                              // onClick={() =>
                              //   navigate("/VitalDetails", {
                              //     state: { patientCode: user.patientCode },
                              //   })
                              // }
                              onClick={() =>
                                navigate("/BookServicescard", {
                                  state: {
                                    patientCode: user.patientCode,
                                    patient: user,
                                  },
                                })
                              }
                            >
                              Book
                            </button>
                          </td>
                          <td className="p-2 align-top">
                            <div className="flex flex-col gap-2">
                              <PatientShareLinkButton
                                label="Kavach Link"
                                onClick={() => handleSendKavachLink(user)}
                                disabled={
                                  sendingKavachCode === user.patientCode
                                }
                                isLoading={
                                  sendingKavachCode === user.patientCode
                                }
                              />
                              <PatientShareLinkButton
                                label="Quantum Link"
                                onClick={() => handleSendQuantumLink(user)}
                                disabled={
                                  sendingQuantumCode === user.patientCode
                                }
                                isLoading={
                                  sendingQuantumCode === user.patientCode
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mt-4 md:mt-8">
            <div className="flex flex-col">
              <label className="text-sm text-[#004276] mb-1 font-medium">
                Salutation
              </label>
              <select
                name="salutation"
                value={formData.salutation}
                onChange={handleChange}
                className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
              >
                <option value="">Select Salutation</option>
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
              </select>
            </div>
            <InputField
              label="First Name"
              name="firstname"
              value={formData.firstname}
              onChange={handleChange}
            />
            <InputField
              label="Last Name"
              name="lastname"
              value={formData.lastname}
              onChange={handleChange}
            />

            <div className="flex flex-col">
              <label className="text-sm text-[#004276] mb-1 font-medium">
                Gender <span className="text-red-500 text-base">*</span>
              </label>

              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                required
                className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
            {parentCode && (
              <div className="flex flex-col">
                <label className="text-sm text-[#004276] mb-1 font-medium">
                  Relation
                </label>
                <select
                  name="relation"
                  value={formData.relation}
                  onChange={handleChange}
                  required
                  className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
                >
                  <option value="">Select Relation</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Sister">Sister</option>
                  <option value="Brother">Brother</option>
                  <option value="Daughter">Daughter</option>
                  <option value="Son">Son</option>
                  <option value="Spouse">Spouse</option>
                  <option value="Grandparent">Grandparent</option>
                </select>
              </div>
            )}

            {/* <InputField
              label="Date of Birth"
              name="dob"
              type="date"
              value={formData.dob}
              onChange={handleChange}
              max={new Date().toISOString().split("T")[0]} // 👈 restricts to today or earlier
            /> */}
            <div className="flex flex-col">
              <label className="text-sm text-[#004276] mb-1 font-medium">
                Date of Birth <span className="text-red-500 text-base">*</span>
              </label>
              <DatePicker
                value={formData.dob ? dayjs(formData.dob) : null}
                onChange={(date) =>
                  handleChange({
                    target: {
                      name: "dob",
                      value: date ? date.format("YYYY-MM-DD") : "",
                    },
                  })
                }
                format="DD-MM-YYYY"
                disabledDate={(current) =>
                  current && current >= dayjs().startOf("day")
                }
                placeholder="DD-MM-YYYY"
                status={dobError ? "error" : undefined}
                className={`w-full rounded-lg px-3 py-2 ${
                  dobError ? "border border-red-500" : "border border-gray-200"
                }`}
              />
              {dobError && (
                <p className="mt-1 text-red-500 text-xs">{dobError}</p>
              )}
            </div>

            {/* <InputField
              label="Age"
              name="age"
              type="number"
              value={formData.age}
              onChange={handleChange}
              placeholder={formData.dob ? "Calculated from DOB" : "Enter age manually"}
              readOnly={formData.dob ? true : false}
            /> */}

            {/* <InputField
              label="Mobile Number"
              name="mobile"
              type="tel"
              value={formData.mobile}
              onChange={handleChange}
              minLength={10}
              maxLength={10}
            /> */}

            <div className="flex flex-col">
              <div className="flex items-center">
                <label className="text-sm text-[#004276] mb-1 font-medium">
                  Mobile Number{" "}
                  <span className="text-red-500 text-base">*</span>
                </label>

                {/* {parentCode && mobileNumber && (
                  <button
                    type="button"
                    className=" text-white hover:underline focus:outline-none ml-1 text-sm bg-[#4ade80] rounded-md px-2"
                    onClick={() =>
                      setFormData((f) => ({ ...f, mobile: mobileNumber }))
                    }
                  >
                    Use same mobile number for family member
                  </button>
                )} */}
              </div>

              <div className="relative flex">
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter here"
                  required
                  minLength={10}
                  maxLength={10}
                  className={`rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition flex-1 ${
                    formData.mobile && formData.mobile.length !== 10
                      ? "border-red-500 focus:ring-red-500"
                      : "border-gray-200"
                  }`}
                />
                {!disabledFeatures.includes("ABDM") && (
                  <>
                    {formData.mobile.length === 10 && !isAbhaVerified && (
                      <button
                        type="button"
                        className="ml-2 px-4 py-2 bg-[#004276] text-white text-sm rounded-lg hover:bg-[#003366] transition duration-200 font-medium whitespace-nowrap"
                        onClick={() => setShowAbhaModal(true)}
                      >
                        Verify ABHA
                      </button>
                    )}
                    {isAbhaVerified && (
                      <div className="ml-2 px-4 py-2 bg-green-100 text-green-700 text-sm rounded-lg flex items-center">
                        <span className="mr-2">✓</span>
                        ABHA Verified
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Mobile number validation error */}
              {formData.mobile && formData.mobile.length !== 10 && (
                <div className="mt-1 text-red-500 text-xs">
                  Please enter a 10 digit mobile number
                </div>
              )}

              {/* Display ABHA information when verified */}
              {isAbhaVerified && formData.abhaNumber && (
                <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="text-sm text-blue-800">
                    <div>
                      <strong>ABHA Number:</strong> {formData.abhaNumber}
                    </div>
                    {formData.preferredAbhaAddress && (
                      <div>
                        <strong>ABHA Address:</strong>{" "}
                        {formData.preferredAbhaAddress}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="flex flex-col">
              <div className="flex items-center">
                <label className="text-sm text-[#004276] mb-1 font-medium">
                  Alternate Mobile Number{" "}
                </label>

                {/* {parentCode && mobileNumber && (
                  <button
                    type="button"
                    className=" text-white hover:underline focus:outline-none ml-1 text-sm bg-[#4ade80] rounded-md px-2"
                    onClick={() =>
                      setFormData((f) => ({ ...f, mobile: mobileNumber }))
                    }
                  >
                    Use same mobile number for family member
                  </button>
                )} */}
              </div>

              <div className="relative flex">
                <input
                  type="tel"
                  name="alternateMobile"
                  value={formData.alternateMobile}
                  onChange={handleChange}
                  placeholder="Enter here"
                  required
                  minLength={10}
                  maxLength={10}
                  className={`rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition flex-1 ${
                    formData.alternateMobile &&
                    formData.alternateMobile.length !== 10
                      ? "border-red-500 focus:ring-red-500"
                      : "border-gray-200"
                  }`}
                />
              </div>
              {alternateMobileError && (
                <p className="text-red-500 text-xs mt-1">
                  {alternateMobileError}
                </p>
              )}
            </div>

            <InputField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
            <InputField
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />
            <div className="flex flex-col">
              <label className="text-sm text-[#004276] mb-1 font-medium">
                Pin Code <span className="text-red-500 text-base">*</span>
              </label>
              <input
                type="text"
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                placeholder="Enter 6-digit pincode"
                required
                minLength={6}
                maxLength={6}
                className={`rounded-lg border px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition ${
                  formData.pinCode && formData.pinCode.length !== 6
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-200"
                }`}
              />
              {formData.pinCode && formData.pinCode.length !== 6 && (
                <div className="mt-1 text-red-500 text-xs">
                  Please enter a valid 6-digit pincode
                </div>
              )}
            </div>
            <div className="flex flex-col">
              <label
                className="text-sm text-[#004276] mb-1 font-medium"
                htmlFor="patient-state"
              >
                State
              </label>
              <State
                id="patient-state"
                name="state"
                value={formData.state}
                onChange={handleChange}
                disabled={Boolean(fetchedState)}
                className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition bg-white disabled:bg-gray-50 disabled:text-gray-600"
              />
              {/* {!fetchedState && (
                <p className="mt-1 text-xs text-gray-500">
                  Select state, or enter pincode to auto-fill
                </p>
              )} */}
            </div>
            <div className="flex flex-col">
              {/* <label className="text-sm text-[#004276] mb-1 font-medium">
                Chief Complaint{" "}
                <span className="text-red-500 text-base">*</span>
              </label> */}

              {/* <Select
                mode="tags"
                placeholder="Select or type Chief Complaint"
                value={formData.chiefComplaint}
                onChange={(value) =>
                  setFormData((prev) => ({ ...prev, chiefComplaint: value }))
                }
                className="w-full border border-gray-200 rounded-lg"
              >
                {symptomsList.map((symptom) => (
                  <Option key={symptom.symptomsId} value={symptom.symptomsName}>
                    {symptom.symptomsName}
                  </Option>
                ))}
              </Select> */}

              {/* <Select
                mode="tags"
                placeholder="Select or type Chief Complaint"
                value={formData.chiefComplaint ? [formData.chiefComplaint] : []}
                onChange={(value) =>
                  handleChange({
                    target: {
                      name: "chiefComplaint",
                      value: value[0], // store only the first item for now
                    },
                  })
                }
                className="w-full border border-gray-200 rounded-lg"
              >
                {symptomsList.map((symptom) => (
                  <Option key={symptom.symptomsId} value={symptom.symptomsName}>
                    {symptom.symptomsName}
                  </Option>
                ))}
              </Select> */}
            </div>
          </div>
          {!submitted && (
            <div className="flex flex-col items-center mt-8 md:mt-10">
              <button
                onClick={handleNext}
                disabled={!isFormValid() || isLoggingIn}
                className="bg-gradient-to-r w-full sm:w-[335px] from-[#004172] to-[#3cba84] text-white rounded-full px-10 py-2 font-medium disabled:opacity-50"
              >
                {isLoggingIn ? "Loading..." : "Submit"}
              </button>
            </div>
          )}
          {submitted && (
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-8 md:mt-10">
              <button
                type="button"
                disabled={vitalsData}
                className={`px-6 py-2 rounded-full border transition font-medium ${
                  vitalsData
                    ? "bg-[#3cba84] border-[#3cba84] text-white cursor-not-allowed opacity-75"
                    : "border-[#004276] text-[#004276] hover:bg-[#004276] hover:text-white"
                }`}
                onClick={vitalsData ? undefined : handleAddVitalsClick}
              >
                {vitalsData ? "✓ Added Vitals" : "Add Vitals"}
              </button>
              <button
                type="button"
                disabled={medicalData}
                className={`px-6 py-2 rounded-full border transition font-medium ${
                  medicalData
                    ? "bg-[#3cba84] border-[#3cba84] text-white cursor-not-allowed opacity-75"
                    : "border-[#004276] text-[#004276] hover:bg-[#004276] hover:text-white"
                }`}
                onClick={medicalData ? undefined : handleAddMedicalClick}
              >
                {medicalData
                  ? "✓ Added Medical History"
                  : "Add Medical History"}
              </button>
              <button
                type="button"
                className="bg-gradient-to-r  from-[#004172] to-[#3cba84] text-white rounded-full px-10 py-2 font-medium disabled:opacity-50"
                // onClick={() =>
                //   navigate(APP_ROUTES.SLOTBOOKING, {
                //     state: { patientCode: createdPatientId },
                //   })
                // }
                onClick={() =>
                  navigate("/BookServicescard", {
                    state: {
                      patientCode: createdPatientId,
                      patient: createdPatientData,
                      patientcbcode: createdCurebayPatientId,
                    },
                  })
                }
              >
                Next
              </button>
            </div>
          )}

          {openModal && (
            <Modal
              title={
                <div
                  style={{
                    backgroundColor: "#e6f7ff",
                    padding: "12px 24px",
                    margin: "-24px -24px 0 -24px",
                  }}
                >
                  Add Vitals
                </div>
              }
              open={openModal}
              onCancel={() => setOpenModal(false)}
              footer={null}
              width="75%"
            >
              <VitalDetails
                patientCode={createdPatientId}
                onCancel={() => setOpenModal(false)}
                onComplete={handleVitalsComplete}
                smartvital={true}
              />
            </Modal>
          )}
          {openModal2 && (
            <Modal
              title="Add Medical History"
              open={openModal2}
              onCancel={() => setOpenModal2(false)}
              footer={null}
              width="75%"
            >
              <MedicalhistoryPage
                patientCode={createdPatientId}
                onCancel={() => setOpenModal2(false)}
                onComplete={handleMedicalComplete}
              />
            </Modal>
          )}

          {showVitalsData && vitalsData && (
            <Modal
              title={
                <div
                  style={{
                    backgroundColor: "#e6f7ff",
                    padding: "12px 24px",
                    margin: "-24px -24px 0 -24px",
                  }}
                >
                  Vital Details
                </div>
              }
              open={showVitalsData}
              onCancel={() => setShowVitalsData(false)}
              footer={[
                <button
                  key="close"
                  onClick={() => setShowVitalsData(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                >
                  Close
                </button>,
              ]}
              width="75%"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {vitalsData.temperature && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Temperature
                    </h3>
                    <p className="text-lg">{vitalsData.temperature}°F</p>
                  </div>
                )}
                {vitalsData.respirationRate && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Respiration Rate
                    </h3>
                    <p className="text-lg">{vitalsData.respirationRate} bpm</p>
                  </div>
                )}
                {vitalsData.bloodPressureSystolic &&
                  vitalsData.bloodPressureDiastolic && (
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-[#004276] mb-2">
                        Blood Pressure
                      </h3>
                      <p className="text-lg">
                        {vitalsData.bloodPressureSystolic}/
                        {vitalsData.bloodPressureDiastolic} mmHg
                      </p>
                    </div>
                  )}
                {vitalsData.heartRate && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Heart Rate
                    </h3>
                    <p className="text-lg">{vitalsData.heartRate} bpm</p>
                  </div>
                )}
                {vitalsData.weightInKg && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Weight
                    </h3>
                    <p className="text-lg">{vitalsData.weightInKg} kg</p>
                  </div>
                )}
                {vitalsData.heightFeet || vitalsData.heightInches ? (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Height
                    </h3>
                    <p className="text-lg">{`${vitalsData.heightFeet || 0}' ${
                      vitalsData.heightInches || 0
                    }\"`}</p>
                  </div>
                ) : vitalsData.heightCm ? (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Height
                    </h3>
                    <p className="text-lg">{vitalsData.heightCm} cm</p>
                  </div>
                ) : null}
                {vitalsData.bmi && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">BMI</h3>
                    <p className="text-lg">{vitalsData.bmi} kg/m²</p>
                  </div>
                )}
                {vitalsData.bloodGlucose && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Blood Glucose
                    </h3>
                    <p className="text-lg">{vitalsData.bloodGlucose} mg/dL</p>
                  </div>
                )}
                {vitalsData.oxygenLevel && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Oxygen Level
                    </h3>
                    <p className="text-lg">{vitalsData.oxygenLevel}%</p>
                  </div>
                )}
              </div>
            </Modal>
          )}

          {showMedicalData && medicalData && (
            <Modal
              title={
                <div
                  style={{
                    backgroundColor: "#e6f7ff",
                    padding: "12px 24px",
                    margin: "-24px -24px 0 -24px",
                  }}
                >
                  Medical History
                </div>
              }
              open={showMedicalData}
              onCancel={() => setShowMedicalData(false)}
              footer={[
                <button
                  key="close"
                  onClick={() => setShowMedicalData(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition"
                >
                  Close
                </button>,
              ]}
              width="75%"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {medicalData.allergyHistory && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Allergy History
                    </h3>
                    <p className="text-sm whitespace-pre-wrap">
                      {medicalData.allergyHistory}
                    </p>
                  </div>
                )}
                {medicalData.medicalHistory && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Medical History
                    </h3>
                    <p className="text-sm whitespace-pre-wrap">
                      {medicalData.medicalHistory}
                    </p>
                  </div>
                )}
                {medicalData.surgicalHistory && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Surgical History
                    </h3>
                    <p className="text-sm whitespace-pre-wrap">
                      {medicalData.surgicalHistory}
                    </p>
                  </div>
                )}
                {medicalData.familyHistory && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Family History
                    </h3>
                    <p className="text-sm whitespace-pre-wrap">
                      {medicalData.familyHistory}
                    </p>
                  </div>
                )}
                {medicalData.socialHistory && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Social History
                    </h3>
                    <p className="text-sm whitespace-pre-wrap">
                      {medicalData.socialHistory}
                    </p>
                  </div>
                )}
                {medicalData.medication && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      Medication
                    </h3>
                    <p className="text-sm whitespace-pre-wrap">
                      {medicalData.medication}
                    </p>
                  </div>
                )}
                {/* Prescription and Lab Reports with preview like PatientPreview */}
                {prescriptionUrl && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      View Prescription
                    </h3>
                    <div
                      className="relative bg-[#f5faff] rounded-md border p-4 cursor-pointer hover:shadow"
                      onClick={() =>
                        setPreviewFile({
                          name: "Prescription",
                          url: prescriptionUrl,
                          type: prescriptionUrl.includes(".pdf")
                            ? "application/pdf"
                            : "image/jpeg",
                        }) || setShowPreview(true)
                      }
                    >
                      <p className="text-sm text-blue-800 font-medium underline">
                        Click to preview prescription
                      </p>
                    </div>
                  </div>
                )}
                {labReports.length > 0 && (
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-[#004276] mb-2">
                      View Lab Reports
                    </h3>
                    <div className="space-y-3">
                      {labReports.map((report, index) => (
                        <div
                          key={index}
                          className="relative bg-[#f5faff] rounded-md border p-4 cursor-pointer hover:shadow"
                          onClick={() =>
                            setPreviewFile({
                              name: `Lab Report ${index + 1}`,
                              url: report.signedUrl,
                              type: report.signedUrl.includes(".pdf")
                                ? "application/pdf"
                                : "image/jpeg",
                            }) || setShowPreview(true)
                          }
                        >
                          <p className="text-sm text-blue-800 font-medium underline">
                            Click to preview Lab Report {index + 1}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          )}

          {showPreview && previewFile && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4">
              <div className="bg-white w-full max-w-md md:max-w-2xl lg:max-w-4xl max-h-[90vh] rounded-2xl overflow-auto shadow-2xl">
                <div className="flex items-center justify-between p-6 border-b">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {previewFile.name}
                  </h3>
                  <button
                    onClick={() => setShowPreview(false)}
                    className="p-2 text-gray-600"
                  >
                    ✕
                  </button>
                </div>
                <div className="p-6">
                  {previewFile.type?.startsWith("image/") ? (
                    <img
                      src={previewFile.url}
                      className="max-w-full h-auto rounded"
                    />
                  ) : previewFile.type === "application/pdf" ? (
                    <iframe
                      src={previewFile.url}
                      className="w-full h-96 rounded"
                    />
                  ) : (
                    <p className="text-center text-gray-500">
                      No preview available
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          <VerifyAbhaModal
            visible={showAbhaModal}
            onClose={() => setShowAbhaModal(false)}
            mobileNumber={formData.mobile}
            onSuccess={(abhaData) => {
              console.log("ABHA verified successfully:", abhaData);
              toast.success("ABHA verified successfully!");
              setIsAbhaVerified(true);
              setShowAbhaModal(false);

              // Store ABHA data in form state
              if (abhaData) {
                let abhaNumber = "";
                let preferredAbhaAddress = "";

                // Handle different data structures from verification vs creation
                if (abhaData.abhaProfile) {
                  // From verification
                  abhaNumber = abhaData.abhaProfile.abhaNumber || "";
                  preferredAbhaAddress =
                    abhaData.abhaProfile.preferredAbhaAddress || "";
                } else if (abhaData.healthIdNumber) {
                  // From creation
                  abhaNumber = abhaData.healthIdNumber || "";
                  preferredAbhaAddress = abhaData.preferredAbhaAddress || "";
                }

                setFormData((prev) => ({
                  ...prev,
                  abhaNumber,
                  preferredAbhaAddress,
                }));
              }
            }}
            onCreateAbha={() => {
              setShowAbhaModal(false); // Close verify modal first
              setShowCreateAbhaModal(true); // Show create modal
            }}
          />

          {showCreateAbhaModal && (
            <CreateAbhaModal
              isOpen={showCreateAbhaModal}
              onClose={() => setShowCreateAbhaModal(false)}
              initialMobileNumber={formData.mobile}
              showAsModal={true}
              onSuccess={(abhaData) => {
                console.log("ABHA created successfully:", abhaData);
                toast.success("ABHA created successfully!");
                setShowCreateAbhaModal(false);
                setIsAbhaVerified(true);

                // Store ABHA data in form state
                if (abhaData) {
                  let abhaNumber = "";
                  let preferredAbhaAddress = "";

                  // Handle different data structures from verification vs creation
                  if (abhaData.abhaProfile) {
                    // From verification
                    abhaNumber = abhaData.abhaProfile.abhaNumber || "";
                    preferredAbhaAddress =
                      abhaData.abhaProfile.preferredAbhaAddress || "";
                  } else if (abhaData.healthIdNumber) {
                    // From creation
                    abhaNumber = abhaData.healthIdNumber || "";
                    preferredAbhaAddress = abhaData.preferredAbhaAddress || "";
                  }

                  setFormData((prev) => ({
                    ...prev,
                    abhaNumber,
                    preferredAbhaAddress,
                  }));
                }
              }}
            />
          )}

          {/* ABHA Verification Modal */}
          {isAbhaVerifyOpen && selectedPatientForAbha && (
            <VerifyAbhaModal
              visible={isAbhaVerifyOpen}
              onClose={handleAbhaClose}
              mobileNumber={selectedPatientForAbha.mobileNumber}
              onSuccess={handleAbhaSuccess}
              onCreateAbha={() => {
                setIsAbhaVerifyOpen(false);
                setIsAbhaCreateOpen(true);
              }}
            />
          )}

          {/* ABHA Creation Modal */}
          {isAbhaCreateOpen && selectedPatientForAbha && (
            <CreateAbhaModal
              isOpen={isAbhaCreateOpen}
              onClose={handleAbhaClose}
              onSuccess={handleAbhaSuccess}
              initialMobileNumber={selectedPatientForAbha.mobileNumber}
              showAsModal={true}
            />
          )}
        </div>
      </DashboardLayout>
    </>
  );
}

// function InputField({
//   label,
//   name,
//   value,
//   onChange,
//   type = "text",
//   showRequired = true,
//   ...rest
// }) {
//   return (
//     <div className="flex flex-col">
//       <label className="text-sm text-[#004276] mb-1 font-medium">
//         {label}{" "}
//         {showRequired && <span className="text-red-500 text-base">*</span>}
//       </label>
//       <input
//         type={type}
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder="Enter here"
//         requir
//         required={showRequired}
//         ed
//         {...rest}
//         className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
//       />
//     </div>
//   );
// }

function InputField({
  label,
  name,
  value,
  onChange,
  type = "text",
  showRequired = true,
  ...rest
}) {
  const isDateField = name === "dob";

  return (
    <div className="flex flex-col">
      <label className="text-sm text-[#004276] mb-1 font-medium">
        {label}{" "}
        {showRequired && <span className="text-red-500 text-base">*</span>}
      </label>

      {/* {isDateField ? (
        <DatePicker
          value={value ? dayjs(value) : null}
          onChange={(date) =>
            onChange({
              target: {
                name,
                value: date ? date.format("YYYY-MM-DD") : "",
              },
            })
          }
          format="DD-MM-YYYY"
          disabledDate={(current) =>
            current && current >= dayjs().startOf("day")
          }
          placeholder="DD-MM-YYYY"
          className="w-full border border-gray-200 rounded-lg px-3 py-2"
        />
      ) : ( */}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder="Enter here"
        required={showRequired}
        {...rest}
        className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
      />
      {/* )} */}
    </div>
  );
}

export default Patientregister;
